// Phase 4 UX (Feb 2026): user-friendly labels for the internal shift
// status values. Backend stays on its internal keywords (open, assigned,
// in_progress, completed, cancelled) — the UI shows human wording only.
//
//   open        → "Waiting for workers"          (no applicants yet)
//   open + apps → "Workers available"            (managers should choose)
//   assigned    → "Confirmed"
//   in_progress → "In progress"
//   completed   → "Completed"
//   cancelled   → "Cancelled"
//   needs_review→ "Needs attention"               (client-derived)
//
// Additionally we compute a semantic tone (neutral | primary | success |
// warning | danger) so callers can choose their own colour treatment
// without having to duplicate this logic in every card.

const STATUS_MAP = {
  open: { label: 'Waiting for workers', tone: 'neutral' },
  assigned: { label: 'Confirmed', tone: 'success' },
  in_progress: { label: 'In progress', tone: 'primary' },
  completed: { label: 'Completed', tone: 'success' },
  cancelled: { label: 'Cancelled', tone: 'danger' },
};

export function getShiftStatus(shift) {
  if (!shift || !shift.status) return { label: '—', tone: 'neutral' };
  // Special case: an open shift with applicants is really "Workers available"
  // — much clearer for a manager scanning their list.
  if (shift.status === 'open' && (shift.applicantCount || 0) > 0) {
    return { label: 'Workers available', tone: 'warning' };
  }
  return STATUS_MAP[shift.status] || { label: shift.status, tone: 'neutral' };
}

// Tailwind class helper for the tone returned above. Kept in one place so
// every card / badge shares the same colour language.
export function statusToneClasses(tone) {
  switch (tone) {
    case 'primary': return 'bg-blue-100 text-blue-800';
    case 'success': return 'bg-emerald-100 text-emerald-800';
    case 'warning': return 'bg-amber-100 text-amber-800';
    case 'danger':  return 'bg-red-100 text-red-800';
    default:        return 'bg-slate-100 text-slate-700';
  }
}
